import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Speed time to value`,
  description: `Realize faster value with best-in-class solution architects and technical expertise, steered by a proven and repeatable framework that drives an accelerated return on investment.`,
}

const SpeedTimeToValue: FC = () => (
  <StyledSectionBase variant="centered">
    <Section.Copy>
      <CopyTextBase centered={true}>
        <CopyText.Heading variant="h2" tag="h2">
          {copy.heading}
        </CopyText.Heading>
        <CopyText.Description variant="pMedium" tag="p">
          {copy.description}
        </CopyText.Description>
      </CopyTextBase>
    </Section.Copy>
  </StyledSectionBase>
)

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 0;
  }

  ${Section.Copy} {
    max-width: 684px;
  }
`

export default SpeedTimeToValue
